
import { Drawer, Input } from "element-ui"
import _ from "lodash"
import drawerHeader from "./components/drawerHeader.vue"
import collapseTransition from "@/library/collapse-transition.js"

export default {
  name: "EditRecipient",
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    collapseTransition,
    drawerHeader
  },
  directives: {
    "click-outside": {
      inserted: function (el, binding, vnode) {
        const parentEl = document.getElementById("edit-recipient-item-select")
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target)) && !(parentEl && parentEl.contains(event.target))) {
            if (typeof vnode.context[binding.expression] === "function") {
              vnode.context[binding.expression](event)
            }
          }
        }
        document.body.addEventListener("click", el.event, true)
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.event, true)
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    recipientInfo: {
      type: Object,
      default: () => {}
    },
    saveAutoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curVisible: this.visible,
      curRecipientInfo: {},
      oldRecipientInfo: {},
      codeOptions: [
        {
          value: "+852",
          label: "+852"
        },
        {
          value: "+853",
          label: "+853"
        },
        {
          value: "+86",
          label: "+86"
        }
      ],
      codeListShow: false,
      invalid: false,
      invalidText: ""
    }
  },
  computed: {
    isSaveDisabled() {
      const { name, code, num } = this.curRecipientInfo
      const { name: oldName, code: oldCode, num: oldNum } = this.oldRecipientInfo
      if (this.invalid) {
        return true
      }
      if (!name || !code || !num) {
        return true
      }
      if (
        name &&
        oldName &&
        name === oldName &&
        code &&
        oldCode &&
        code === oldCode &&
        num &&
        oldNum &&
        num === oldNum
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
      if (val) {
        console.log("this.recipientInfo", this.recipientInfo)
        this.resetInvalidNotice()
        this.curRecipientInfo = _.cloneDeep(this.recipientInfo)
        this.oldRecipientInfo = _.cloneDeep(this.recipientInfo)
      }
    }
  },
  methods: {
    resetInvalidNotice() {
      this.invalid = false
      this.invalidText = ""
    },
    hideCodeList() {
      this.codeListShow = false
    },
    toggleCodeListShow() {
      this.codeListShow = !this.codeListShow
    },
    handleSelect(item) {
      if (this.curRecipientInfo.code !== item.value) {
        this.curRecipientInfo.code = item.value
        this.checkInput()
      }
      this.hideCodeList()
    },
    handleInput(value) {
      // 限制输入数字
      this.curRecipientInfo.num = value.replace(/[^\d]/g, "")

      this.$nextTick(() => {
        this.checkInput()
      })
    },
    checkInput() {
      const { code, num } = this.curRecipientInfo
      if (code === "+86") {
        // 限制11位数 || 1开头
        if (num.length !== 11 || !/^1\d{10}$/.test(num)) {
          this.invalid = true
          this.invalidText = this.$t("cart.recipientWarningTextWith11Digits")
        } else {
          this.resetInvalidNotice()
        }
      } else {
        // 限制8位数

        if (num.length !== 8) {
          this.invalid = true
          this.invalidText = this.$t("cart.recipientWarningTextWith8Digits")
        } else {
          this.resetInvalidNotice()
        }
      }
    },
    handleClose() {
      this.$emit("close")
    },
    handleSave() {
      console.log("handleSave", this.curRecipientInfo)
      this.$emit("save", this.curRecipientInfo)
      if (this.saveAutoClose) {
        this.handleClose()
      }
    }
  }
}
